"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusColumnConfig = exports.statesColumnConfig = exports.sexColumnConfig = exports.renderNameColumn = exports.companyColumnConfig = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Sex = _utils.GenderUtils.Sex;
var UsaStates = _utils.UsaStatesUtils.UsaStates;
var renderNameColumn = function renderNameColumn(text, record) {
  var name = (0, _utils.composeName)([record.lastName, record.firstName]);
  return {
    props: {
      className: 'ellipsis-text'
    },
    children: /*#__PURE__*/_react.default.createElement("span", {
      title: name
    }, name)
  };
};
exports.renderNameColumn = renderNameColumn;
var companyColumnConfig = (0, _utils.reformatDictionary)(Object.entries(_utils.CompanyIds).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    label = _ref2[0],
    id = _ref2[1];
  return {
    label: label,
    id: id
  };
}));
exports.companyColumnConfig = companyColumnConfig;
var statusColumnConfig = (0, _utils.reformatDictionary)(Object.entries(_utils.AccountStatus).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    label = _ref4[0],
    id = _ref4[1];
  return {
    label: label,
    id: id
  };
}));
exports.statusColumnConfig = statusColumnConfig;
var sexColumnConfig = (0, _utils.reformatDictionary)(Object.entries(Sex).map(function (_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
    label = _ref6[0],
    id = _ref6[1];
  return {
    label: label,
    id: id
  };
}));
exports.sexColumnConfig = sexColumnConfig;
var statesColumnConfig = (0, _utils.reformatDictionary)(UsaStates.map(function (_ref7) {
  var abbreviation = _ref7.abbreviation,
    name = _ref7.name;
  return {
    id: abbreviation,
    label: name
  };
}));
exports.statesColumnConfig = statesColumnConfig;